// extracted by css-extract-rspack-plugin
export default {"errorWidgetContent":"errorWidgetContent-afMZpj","errorWidgetContentTitle":"errorWidgetContentTitle-Nq81IG","errorWidgetContentButton":"errorWidgetContentButton-JMfuaI"};